<template>
  <div>
    <div class="row f-row">
      <div class="col col-1 docs-titles"></div>
      <div class="col col-11 docs-titles">
        Software Design Document (SDD)
      </div>
    </div>
    <div class="row f-row">
      <div class="col col-1 docs-titles"></div>
      <div class="col col-3 docs-titles">
        Stakeholders
      </div>
      <div class="col col-7 docs-titles">
        Overview
      </div>
      <div class="col col-1 docs-titles"></div>
    </div>
    <div class="row f-row justify-content-center">
      <div class="col col-3 mt-2 mb-2 docs-text">
        <ul>
          <li>
            <span class="active-color">Product Owner:</span> Nicolas Corredor
          </li>
          <li>
            <span class="active-color">Backend-developer:</span> Ivan Herrera
          </li>
          <li><span class="active-color">Backend-developer:</span> ...</li>
          <li><span class="active-color">Frontend-developer:</span> ...</li>
          <li>
            <span class="active-color">User interaction and feedback:</span>
            Carlos Mejia
          </li>
          <li>
            <span class="active-color">User interaction and feedback:</span>
            Santiago Benitez
          </li>
        </ul>
      </div>
      <div class="col col-7 mt-2 mb-2 docs-text">
        <span class="qs-font active-color">QUANSPIRE</span> is a software design
        with principles of micro services. We use rest-api for the on-demand
        requirement of the client, and we also use websockets to inject
        information about he market and certain messages for the client.
        <ul>
          <li><span class="active-color">DB:</span> PostgreSQL</li>
          <li>
            <span class="active-color">Backend:</span> python with the framework
            Django. Model definition, users, business logic analytics and
            calculations.
          </li>
          <li>
            <span class="active-color">Extract automation:</span> automate the
            extraction of market data from multiple sources. main source is
            Refinitiv, but we also use various APIs to get intra-day, end of
            day, weekly, month information.
          </li>
          <li>
            <span class="active-color">Data transfer:</span> built in python
            (Django), this API is design to read, process and save to database
            all the client's data. We read directly from Data Model from the
            platform, but are also flexible in being able to read Excel
            Spreadsheets designed by the client. We will be able to read from
            the client's DB, FTP, data repositories, emails, etc, with or
            without VPN.
          </li>
          <li>
            <span class="active-color">Api-gateway:</span> built NodeJS all the
            information flowing to the front end, passes through the API
            gateway.
          </li>
          <li>
            <span class="active-color">Front end:</span> built in Vue.js, we use
            Bootstrap, Vuetify (we plan on stop using it), PrimeVue,
            Font-Awesome and D3.js for all the charts.
          </li>
        </ul>
      </div>
    </div>
    <div class="row f-row">
      <div class="col col-1 docs-titles"></div>
      <div class="col col-11 docs-titles">
        Context and goals
      </div>
    </div>
    <div class="row f-row justify-content-center">
      <div class="col col-10 mt-2 mb-2 docs-text">
        <span class="qs-font active-color">QUANSPIRE</span> is a company that
        focuses on helping the clients protect their results (income, costs,
        margins) from the volatility's of variables that they normally don't
        control: currencies and commodities (and interest rates in the future).
        <br />
        Clients tend to use market information platforms such as Bloomberg and
        Reuters if they are big companies, but most of the companies use free
        web pages such as TradingView, Investing, and -biased- platforms
        provided by the banks, but all those platforms only provide them with
        valuations and market information for a part of all the information they
        need to process. That's why they normally create in-house analyzes
        (mostly Excel models) to be able to answer the basic questions and be
        able to make decisions.
        <br />
        Our platform aims to meet all the client's needs regarding the
        implementation of the Risk Management Program of the Company. We focus
        on the client's needs and are currently learning from a small number of
        clients that are guiding us in what tools/analyzes to build into the
        platform. The idea is to try to provide all the tools to our client so
        that they wont need to use Excel, Powerpoint to make decisions and
        communicate the results /risk / expected outcomes.
        <br />
        We are a SaaS platform and our main KPI's are:
        <ul>
          <li>
            <i class="fa fa-check"></i>
            <span class="active-color"> Number of active clients.</span>
          </li>
          <li>
            <i class="fa fa-check"></i> Clients using
            <span class="active-color"> only the platform</span> to analyze and
            communicate results (no Excel | PowerPoint).
          </li>
          <li>
            <i class="fa fa-check"></i> Accuracy of the
            <span class="active-color">market data.</span>
          </li>
          <li>
            <i class="fa fa-check"></i> We focus on the
            <span class="active-color">speed of the analyzes.</span>
          </li>
          <li>
            <i class="fa fa-check"></i> We measure how fast we can
            <span class="active-color"
              >create and update features and analyzes</span
            >
            based on the client's needs.
          </li>
          <li>
            <i class="fa fa-check"></i> We focus on the
            <span class="active-color"
              >simplicity and ease we provide the clients to keep their data
              updated.</span
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="row f-row">
      <div class="col col-1 docs-titles"></div>
      <div class="col col-11 docs-titles">
        Proposed solution
      </div>
    </div>
    <div class="row f-row justify-content-center">
      <div class="col col-10 mt-2 mb-2 text-center">
        <img
          :src="microservices"
          alt=""
          style="padding: 0; image-rendering: crisp-edges;"
        />
      </div>
    </div>
    <div class="row f-row">
      <div class="col col-1 docs-titles"></div>
      <div class="col col-11 docs-titles">
        Timeline
      </div>
    </div>
    <div class="row f-row justify-content-center">
      <div class="col col-1 docs-text">
        <ToggleButton
          :id="'details'"
          :defaultState="true"
          :labelEnableText="'- Details'"
          :labelDisableText="'+ Details'"
          v-on:change="showDetails = !showDetails"
        />
      </div>
      <div class="col col-9 docs-text">
        <ToggleButton
          :id="'sorting'"
          :defaultState="false"
          :labelEnableText="'Sort by Relevance'"
          :labelDisableText="'Sort by App'"
          v-on:change="sortVar = !sortVar"
        />
      </div>
    </div>
    <div v-for="(sddItem, index) in sdd" :key="index" class="mb-3">
      <div class="row f-row justify-content-center bdr-t">
        <div class="col col-4 docs-text">
          <span class="active-color">{{ index + 1 }}: {{ sddItem.title }}</span>
        </div>
        <div class="col col-2 docs-text" style="padding-top: 6px">
          Progress:
          <span class="active-color">({{ sddItem.ave | numFormat }}%)</span>
        </div>
        <div class="col col-3 docs-text" style="padding-top: 6px">
          Relevance:
          <v-progress-circular
            :value="sddItem.relevance"
            :rotate="5"
            :color="colorExpo(colorTheme)"
            :size="16"
            :width="3"
          >
          </v-progress-circular
          >&nbsp;
          <span class="active-color"
            >({{ sddItem.relevance | numFormat }}%)</span
          >
        </div>
        <div class="col col-1 docs-text"></div>
      </div>
      <div class="row f-row justify-content-center">
        <div class="col col-4 docs-text bdr-b"></div>
        <div class="col col-5 docs-text bdr-b" style="padding-top: 6px">
          <ProgressBar :value="sddItem.ave" :showValue="false" />
        </div>
        <div class="col col-1 docs-text bdr-b">
          <span class="ml-5"> {{ sddItem.due | formatDate }} </span>
        </div>
      </div>
      <span v-show="showDetails">
        <div
          class="row f-row justify-content-center"
          v-for="(sddSubItem, idx) in sddItem.items"
          :key="idx"
        >
          <div class="col col-4 docs-text">
            <span style="padding-left: 12px"
              >{{ sddSubItem.title }} ({{ sddSubItem.value | numFormat }}%)
            </span>
          </div>
          <div class="col col-5 docs-text" style="padding-top: 6px">
            <ProgressBar :value="sddSubItem.value" :showValue="false" />
          </div>
          <div class="col col-1 docs-text"></div>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import ProgressBar from "primevue/progressbar";
import ToggleButton from "@/components/ToggleButton.vue";
import { mean, timeParse, format } from "d3";
import moment from "moment";
import { colorExpo } from "@/_core/_helpers/_parametric_tools";
import { getSDD } from "@/_core/data/Documentation";
import { sortByKey, sortByKeyDesc } from "@/_core/_helpers/_helpers";

export default {
  name: "SDD",
  components: {
    ProgressBar,
    ToggleButton
  },
  props: {
    colorTheme: { required: true, type: Boolean, default: true }
  },
  data() {
    return {
      colorExpo: colorExpo,
      microservices: require("@/assets/images/microservicesStructure.png"),
      sdd: [],
      showDetails: true,
      sortVar: false
    };
  },
  created() {
    this.sdd = getSDD();
    this.sddTotalsCalculation();
  },
  methods: {
    sddTotalsCalculation() {
      this.sdd.forEach(function(d) {
        d.ave = mean(d.items, function(d) {
          return d.value;
        });
        d.due = timeParse("%Y-%m-%d")(d.due);
      });
    }
  },
  watch: {
    sortVar() {
      this.sdd = this.sortVar
        ? sortByKeyDesc(this.sdd, "relevance")
        : sortByKey(this.sdd, "idx");
    }
  },
  filters: {
    numFormat: function(val) {
      return val === null || !isFinite(val) || val === 0
        ? "-"
        : format(",.2r")(val);
    },
    formatDate: function(value) {
      if (value) {
        return moment(String(value)).format("DD MMM YY");
      }
    }
  }
};
</script>

<style scoped></style>
